<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>客户维护</el-breadcrumb-item>
      <el-breadcrumb-item>客户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row :gutter="0">
        <el-col :span="10">
          <el-input placeholder="请输入查询内容" v-model="queryInfo.query" class="input-with-select" clearable
            style="width:300px " @clear="getguestList" @change="getguestList">
            <el-button slot="append" icon="el-icon-search" @click="getguestList"></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="get_guest_add" v-if="false">添加客户</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="0" class="el_row_two">
        <el-col :span="24">
          <el-table :data="guestList" style="width: 100%" border stripe>
            <!-- <el-table-column type="index" label="序号" width="80"></el-table-column> -->
            <el-table-column prop="uid" label=" 序号" width="80"></el-table-column>
            <el-table-column prop="guest_bianhao" label=" 编号" width="120"></el-table-column>
            <el-table-column prop="guest_name" label="客户名称"></el-table-column>
            <el-table-column prop="guest_mob" label="手机"></el-table-column>
            <el-table-column prop="guest_addr" label="地址"></el-table-column>
            <el-table-column prop="guest_flag_baiMingdan" label="白名单" width="130">
              <template v-slot="scope">
                <div v-if=" scope.row.guest_flag_baiMingdan"> 白名单用户 </div> 
                    
              </template>
            </el-table-column>
            <el-table-column prop="add_time" label="加入时间"></el-table-column>
            <el-table-column label="操作">
              <template v-slot="scope">
                <el-tooltip class="item" effect="dark" content="修改" placement="top" :enterable="false">
                  <el-button type="primary" icon="el-icon-edit" @click="showEditDialog(scope.row.uid)" circle
                    size="mini"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除" placement="top" :enterable="false">
                  <el-button type="danger" icon="el-icon-delete" circle size="mini"
                    @click="deleteForm(scope.row.uid)"></el-button>
                </el-tooltip>
                <!-- <el-tooltip class="item" effect="dark" content="设置为白名单" placement="top" :enterable="false">
                  <el-button type="danger" icon="el-icon-coordinate" circle size="mini"
                    @click="baiMingdan(scope.row.uid,scope.row.guest_flag_baiMingdan)"></el-button>
                </el-tooltip> -->
                <!-- <el-tooltip class="item" effect="dark" content="客户回访" placement="top" :enterable="false"
                  style="display: none;">
                  <el-button type="success" icon="el-icon-orange" @click="showHuifangDialog(scope.row.uid)" circle
                    size="mini"></el-button>
                </el-tooltip> -->
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <!-- 分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="queryInfo.pageNum" :page-sizes="[10, 50]" :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
        <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
      </el-pagination>
      <!-- 客户回访窗口 -->

      <el-dialog title="客户回访" :visible.sync="huifangDialogVisible" width="50%" @close="huifangDoalogClosed">
        <el-form ref="huifangFormRef" :model="huifangForm" :rules="huifangFormRefRules" label-width="100px">
          <el-card class="card_two" style="height:140px; margin-top:0px; margin-bottom:20px; ">
            <el-row :gutter="20">
              <el-col :span="10">
                <div class="grid-content bg-purple">
                  <el-form-item label="客户编号" prop="guest_bianhao">{{ editForm.guest_bianhao }}</el-form-item>
                  <el-form-item label="客户姓名" prop="guest_name">{{ editForm.guest_name }}</el-form-item>
                </div>
              </el-col>
              <el-col :span="10">
                <div class="grid-content bg-purple">
                  <el-form-item label="联系手机号" prop="guest_mob">{{ editForm.guest_mob }}</el-form-item>
                  <el-form-item label="联系地址" prop="guest_addr">{{ editForm.guest_addr }}</el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-card>
          <el-form-item label="回访标题" prop="huifang_title">
            <el-input v-model="huifangForm.huifang_title" max="11" min="10"></el-input>
          </el-form-item>
          <el-form-item label="回访内容" prop="hufiang_memo">
            <el-input v-model="huifangForm.hufiang_memo" :autosize="{ minRows: 2, maxRows: 8 }" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="是否需要跟进" prop="huifang_genjin">
            <el-switch v-model="huifangForm.huifang_switch"
              @change="get_switch_value(huifangForm.huifang_switch)"></el-switch>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="huifangDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addHuifang" :disabled="huifang_isDisable">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 添加客户部分 -->
      <el-dialog title="添加客户" :visible.sync="addDialogVisible" width="50%" @close="addDoalogClosed">
        <el-form ref="addFormRef" :model="addForm" :rules="addFormRules" label-width="100px">
          <el-form-item label="客户编号" prop="guest_bianhao">
            <el-input v-model="addForm.guest_bianhao" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="客户姓名" prop="guest_name">
            <el-input v-model="addForm.guest_name"></el-input>
          </el-form-item>
          <el-form-item label="联系手机号" prop="guest_mob">
            <el-input v-model="addForm.guest_mob" max="11" min="10"></el-input>
          </el-form-item>
          <el-form-item label="联系地址" prop="guest_addr">
            <el-input v-model="addForm.guest_addr" max="11" min="10"></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="guest_sfz_bianhao">
            <el-input v-model="addForm.guest_sfz_bianhao" max="11" min="10"></el-input>
          </el-form-item>
          <el-form-item label="客户等级" prop="guest_level">
            <el-select v-model="addForm.guest_level" placeholder="请选择客户等级">
              <el-option v-for="item in guest_options" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户心理价位" prop="guest_addr">
            <el-input v-model="addForm.guest_price_want" max="11" min="10"></el-input>
          </el-form-item>
          <el-form-item label="客户意向" prop="guest_addr">
            <el-input v-model="addForm.guest_yixiang" max="11" min="10"></el-input>
          </el-form-item>
          <el-form-item label="客户备注" prop="guest_addr">
            <el-input v-model="addForm.guest_memo" max="11" min="10"></el-input>
          </el-form-item>

          <el-form-item label="客户来源" prop="guest_laiyuan">
            <el-select v-model="addForm.guest_laiyuan" placeholder="请选择客户来源">
              <el-option v-for="item in guestLy_options" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addGuest" :disabled="add_isDisable">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 修改客户信息 -->
      <el-dialog title="修改客户信息" :visible.sync="editDialogVisible" width="50%" @close="editDoalogClosed">
        <el-form ref="editFormRef" :model="editForm" :rules="addFormRules" label-width="100px">
          <el-form-item label="客户编号" prop="guest_bianhao">
            <el-input v-model="editForm.guest_bianhao" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="客户姓名" prop="guest_name">
            <el-input v-model="editForm.guest_name"></el-input>
          </el-form-item>
          <el-form-item label="联系手机号" prop="guest_mob">
            <el-input v-model="editForm.guest_mob" max="11" min="10"></el-input>
          </el-form-item>
          <el-form-item label="选择小区" prop="zhandian_xiaoqu_uid">
            <el-select v-model="editForm.xiaoqu_uid" placeholder="选择小区" @change="getXiaoquList">
              <el-option v-for="item in xiaoquList" :key="item.uid" :label="item.xiaoqu_name"
                :value="item.xiaoqu_uid"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="updateguest">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
import { checkMobileTest, checkSfzId } from './config/validator';
export default {
  data() {
    return {
      guestLy_options: [
      {
          value: 1,
          label: '抖音'
        },
        {
          value: 2,
          label: '美团'
        },
        {
          value: 3,
          label: '自然到店'
        },
        {
          value: 4,
          label: '邀约'
        },
        {
          value: 5,
          label: '转介绍'
        },
        {
          value: 6,
          label: '领券'
        },
        {
          value: 7,
          label: '其他'
        }
      ],
      guest_options: [
        {
          value: 1,
          label: '初级客户'
        },
        {
          value: 2,
          label: '中级客户'
        },
        {
          value: 3,
          label: '高级客户'
        }
      ],
      // 获取用户列表参数
      queryInfo: {
        C_type: 'get_list',
        C_table_name: 'guest_list',
        query: '',
        pageNum: 1,
        pageSize: 10,
        qiye_uid: window.sessionStorage.getItem('qiye_uid')
      },
      huifang_isDisable: false,
      add_isDisable: false,
      guestList: [],
      xiaoquList: [],
      //  recordCount: 0,
      total: 0,
      addDialogVisible: false,
      editDialogVisible: false,
      huifangDialogVisible: false,

      // 用于设置回访页面滑块值
      //  添加表单数据项
      huifangForm: {
        C_type: 'huifang_add',
        huifang_guest_uid: 0,
        huifang_title: '',
        hufiang_memo: '',
        huifang_genjin: 1,
        huifang_yuangong_uid: 0,
        huifang_switch: true
      },
      addForm: {
        C_type: 'guest_add',
        guest_bianhao: '',
        guest_name: '',
        guest_mob: '11111111111',
        guest_addr: '',
        guest_sfz_bianhao: '111111111111111111',
        guest_level: 1,
        guest_price_want: 0,
        guest_yixiang: '',
        guest_memo: '',
        guest_laiyuan: 1
      },
      // 用于修改数据绑定
      editForm: {},
      // 表单规则项
      addFormRules: {
        guest_name: [
          { required: true, message: '请输入客户名称', trigger: 'blur' },
          { min: 2, max: 20, message: '必须2到20位字符 ', trigger: 'blur' }
        ],

        guest_mob: [
          {
            validator: checkMobileTest.bind(
              this.addForm && this.addForm.guest_mob
            )
          }
        ],
        guest_sfz_bianhao: [
          {
            validator: checkSfzId.bind(
              this.addForm && this.addForm.guest_sfz_bianhao
            )
          }
        ]
      },

      huifangFormRefRules: {
        huifang_title: [
          { required: true, message: '请输入回访标题', trigger: 'blur' },
          { min: 1, max: 1000, message: '必须1位字符 ', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    this.getguestList();
    this.getXiaoquList()
  },
  methods: {
    async getXiaoquList() {
      const { data: res } = await this.$http.get('get_api', {
        params: {
          C_type: 'xiaoqu_list_select' // 调用普通api get接口 
        }
      });
      this.xiaoquList = JSON.parse(res.data)[0].dataList
      console.log(this.xiaoquList)
    },

    get_switch_value(switchValue) {
      this.huifangForm.huifang_genjin = switchValue ? 1 : 0;
      console.log(this.huifangForm.huifang_genjin);
    },
    async huiFangAdd() {
      const { data: res } = await this.$http.post('api', this.huifangForm);
      console.log(JSON.parse(res.data)[0].bianhao_s);
      this.huifangDialogVisible = true;
    },
    async get_guest_add() {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_type: 'get_bianhao', C_table_type: 3 }
      });
      console.log(JSON.parse(res.data)[0].bianhao_s);
      this.addForm.guest_bianhao = JSON.parse(res.data)[0].bianhao_s;
      // this.total = JSON.parse(res.data)[0].total
      this.addDialogVisible = true;
    },

    async getguestList() {
      const { data: res } = await this.$http.get('get_api', {
        params: this.queryInfo
      });
        console.log(JSON.parse(res.data)[0].dataList)
      this.guestList = JSON.parse(res.data)[0].dataList 

      if (!this.guestList) return;
      this.guestList.forEach(function (item) {
        item.yong_flag = item.yong_flag === 1;
      });

      this.total = JSON.parse(res.data)[0].total;

      // console.log(this.total)
    },
    //  分页第一项下拉触发

    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getguestList();
    },
    // 选择页数触发
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.getguestList();
    },

    async addGuest() {
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) return 1;
        this.add_isDisable = true
        setTimeout(() => {
          this.add_isDisable = false // 点击一次时隔两秒后才能再次点击
        }, 2000)
        const { data: res } = await this.$http.post('api', this.addForm);
        console.log(JSON.parse(res.data)[0].status);
        if (JSON.parse(res.data)[0].status === 201) {
          this.$message.error('手机号码重复')
          return
        } else if ((JSON.parse(res.data)[0].status !== 200) && (JSON.parse(res.data)[0].status !== 201)) {
          this.$message.error('添加失败')
          return
        }
        this.$message.success('添加成功');
        this.getguestList();
        this.addDialogVisible = false;
      });
    },
    async addHuifang() {
      this.$refs.huifangFormRef.validate(async valid => {
        if (!valid) return 1;
        this.huifang_isDisable = true
        setTimeout(() => {
          this.huifang_isDisable = false // 点击一次时隔两秒后才能再次点击
        }, 2000)

        const { data: res } = await this.$http.post('api', this.huifangForm);
        console.log(JSON.parse(res.data)[0].status);
        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.error('添加失败');
          return;
        }
        this.$message.success('添加成功');
        this.getguestList();
        this.huifangDialogVisible = false;
      });
    },
    showEditDialog(uid) {
      this.guestInfo(uid);
      this.editDialogVisible = true;
    },
    addDoalogClosed() {
      this.$refs.addFormRef.resetFields();
    },
    huifangDoalogClosed() {
      this.$refs.huifangFormRef.resetFields();
    },
    showHuifangDialog(uid) {
      this.huifangDialogVisible = true;
      this.guestInfo(uid);
    },
    editDoalogClosed() {
      this.$refs.editFormRef.resetFields();
    },
    async guestInfo(uid) {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_table_name: 'guest_info', uid: uid, C_type: 'get_info' }
      });
      // console.log(JSON.parse(res.data))
      console.log(res.data);
      if (JSON.parse(res.data)[0].status !== 200) {
        return this.$message.error('读取失败');
      }

      this.editForm = JSON.parse(res.data)[0].data[0];
      this.huifangForm.huifang_guest_uid = JSON.parse(res.data)[0].data[0].uid;
    },
    async updateguest() {
      this.$refs.editFormRef.validate(async valid => {
        if (!valid) return this.$message.error('验证错误！');
        this.editForm.C_type = 'guest_update_sx002';
        // 对象加入一个项C_type
        const { data: res } = await this.$http.post('api', {
          C_type: 'guest_update_sx002',
          guest_name: this.editForm.guest_name,
          guest_mob: this.editForm.guest_mob,
          guest_uid: this.editForm.uid,
          xiaoqu_uid: this.editForm.xiaoqu_uid
        });

        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.error('更新失败');
          return;
        }
        this.$message.success('更新成功');
        this.getguestList();
        this.editDialogVisible = false;
      });
    },
    async deleteForm(guestUid) {
      // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
      // 异步操作有2个，1个对话框等待，1个是网络请求
      const comfirmResult = await this.$confirm(
        '确定删除该条记录, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err);
      console.log(comfirmResult);
      if (comfirmResult === 'cancel') return this.$message.info('已经取消删除');
      const { data: res } = await this.$http.post('api', {
        C_type: 'record_delete',
        C_table_name: 'guest_del',
        C_data1: guestUid
      });
      if (JSON.parse(res.data)[0].status !== 200) {
        this.$message.error('删除失败');
        return;
      }
      this.$message.success('删除成功');
      this.getguestList();
    },

    // 设置白名单
    async baiMingdan(guestUid, baiMingdanFlag) {
      // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
      // 异步操作有2个，1个对话框等待，1个是网络请求
      var flag = 0
      if (baiMingdanFlag) flag = 0
      else flag = 1 
      const comfirmResult = await this.$confirm(
        '确定要设置为白名单吗, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err);
      console.log(comfirmResult);
      if (comfirmResult === 'cancel') return this.$message.info('已经取消删除');
       
      const { data: res } = await this.$http.post('api', {
        C_type: 'guest_baiMingdan',
        guestUid: guestUid,
        baiMingdanFlag: flag
      });
      if (JSON.parse(res.data)[0].status !== 200) {
        this.$message.error('设置失败');
        return;
      }
      this.$message.success('设置成功');
      this.getguestList();
    }
  }
};
</script>
<style lang="less" scoped>
.card_two {
  margin-top: 30px;
  box-shadow: none !important;
  background-color: #f2f6fc;
}

.el_row_two {
  margin-top: 30px;
}
</style>
